export default __webpack_public_path__ + "static/media/borku-GooglePlayStore.e0f2683f.svg";